import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import { makeStyles } from '@mui/styles';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import FindReplaceIcon from '@mui/icons-material/FindReplace';
import MenuIcon from '@mui/icons-material/Menu';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import clsx from 'clsx';
import moment from 'moment';
import React from 'react';
import { Colors } from "../constants/Colors";
import { Fonts } from "../constants/Fonts";
import { getUser, logout } from "../services/auth";
import { isMobile } from "../utils/isMobile";
import { ReturnFirstWord } from '../utils/StringUtils';
import PersonAddDisabledIcon from '@mui/icons-material/PersonAddDisabled';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const drawerWidth = 240;
const DRAWER_TEXT = "Bem vindo - " + new Date().getDay() + '/' + new Date().getMonth() + '/' + new Date().getFullYear();
const LOGO_URL = 'http://www.ijobtech.com/images/ijoblogo02.png'
const DrawerItens = [
    { index: 0, name: "app", displayName: 'Home', IconType: 1 }
    , { index: 1, name: "UserSearch", displayName: 'Buscar usuários', IconType: 2 }
    , { index: 2, name: "JobSearch", displayName: 'Buscar serviço', IconType: 3 }
    , { index: 3, name: "UserInactive", displayName: 'Buscar inativos', IconType: 4 }

]

const useStyles = makeStyles( ( theme ) => ( {
    root: {
        display: 'flex',

    },
    menuButtonRight: {
        flex: 0
    },
    appBar: {
        // transition: theme.transitions.create( [ 'margin', 'width' ], {
        //     easing: theme.transitions.easing.sharp,
        //     duration: theme.transitions.duration.leavingScreen,
        // } ),
        backgroundColor: Colors.Primary
    },
    appBarShift: {
        width: `calc(100% - ${ drawerWidth }px)`,
        marginLeft: drawerWidth,
        // transition: theme.transitions.create( [ 'margin', 'width' ], {
        //     easing: theme.transitions.easing.easeOut,
        //     duration: theme.transitions.duration.enteringScreen,
        // } ),

    },
    menuButton: {
        // marginRight: theme.spacing( 2 ),
        marginRight: 2,

    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,

    },
    drawerPaper: {
        width: drawerWidth,
        backgroundColor: Colors.Primary
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        // padding: theme.spacing( 0, 1 ),
        padding: 1,
        // necessary for content to be below app bar
        // ...theme.mixins.toolbar,

        justifyContent: 'flex-end',
    },
    drawerList: {
        position: 'absolute',
    },
    Iconcolor: {
        backgroundColor: Colors.Primary
    },
    content: {
        flexGrow: 1,
        // padding: theme.spacing( 3 ),
        padding: 3,
        // transition: theme.transitions.create( 'margin', {
        //     easing: theme.transitions.easing.sharp,
        //     duration: theme.transitions.duration.leavingScreen,
        // } ),
        backgroundColor: Colors.White,
        marginLeft: -drawerWidth,
    },
    contentShift: {
        // transition: theme.transitions.create( 'margin', {
        //     easing: theme.transitions.easing.easeOut,
        //     duration: theme.transitions.duration.enteringScreen,
        // } ),
        marginLeft: 0,
    },
    Img: { opacity: 0.7, resizeMode: 'cover' }
} ) );

export const DrawerComponent = ( { children, history } ) =>
{
    const classes = useStyles();
    // const theme = useTheme();

    const [ open, setOpen ] = React.useState( false );
    const handleDrawerOpen = () => { setOpen( true ) }
    const handleDrawerClose = () => { setOpen( false ) }

    function handleLogout ( e )
    {
        logout();
        history.push( "/" );
    }

    function HandleDrawerClick ( item, index )
    {
        history.push( item.name )
    }

    const _returnIcon = ( item ) =>
    {
        switch ( item.IconType )
        {
            case 1:
                return <MoveToInboxIcon color={ 'secondary' } />
            case 2:
                return <FindReplaceIcon color={ 'secondary' } />
            case 3:
                return <AccountBalanceWalletIcon color={ 'secondary' } />
            case 4:
                return <PersonAddDisabledIcon color={ 'secondary' } />
            case 5:
                return <NotificationsIcon color={ 'secondary' } />
        }
    }



    return (
        <div className={ classes.root }>
            <CssBaseline />
            <AppBar position="fixed" className={ clsx( classes.appBar, { [ classes.appBarShift ]: open } ) }>
                <Toolbar style={ { display: 'flex' } }>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={ handleDrawerOpen }
                        edge="start"
                        className={ clsx( classes.menuButton, open && classes.hide ) }>
                        <MenuIcon />
                    </IconButton>

                    <Typography variant="h6" noWrap style={ { fontFamily: Fonts.Primary, flex: 1 } }>
                        { moment().format( 'DD/MM/yyyy' ) + ' 👤 ' + ReturnFirstWord( getUser() ) }
                    </Typography>

                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={ handleLogout }
                        edge="start"
                        className={ clsx( classes.menuButtonRight ) }>
                        <ExitToAppIcon />
                    </IconButton>

                </Toolbar>
            </AppBar>
            <Drawer
                className={ classes.drawer }
                variant="persistent"
                anchor="left"
                open={ open }
                classes={ { paper: classes.drawerPaper, } }>

                <div className={ classes.drawerHeader }>
                    <img src={ LOGO_URL } className={ classes.Img } alt="logo" />
                    <IconButton onClick={ handleDrawerClose }>
                        {/* { theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon /> } */ }
                        { open ? <ChevronLeftIcon /> : <ChevronRightIcon /> }
                    </IconButton>
                </div>

                <div className={ classes.drawerList }>
                    <List>
                        { DrawerItens.map( ( item, index ) => (
                            <ListItem button key={ item.displayName } onClick={ () => HandleDrawerClick( item, index ) }>

                                <ListItemIcon>{ _returnIcon( item ) }</ListItemIcon>

                                <Typography variant="caption" noWrap style={ { fontFamily: Fonts.Primary, color: Colors.White, fontWeight: '650' } }>{ item.displayName }</Typography>
                            </ListItem>
                        ) ) }
                    </List>
                </div>
                {/* <Divider /> */ }
            </Drawer>
            <main className={ clsx( classes.content, { [ classes.contentShift ]: open, } ) }>
                <div className={ classes.drawerHeader } />
                { children }
            </main>


        </div>

    );
}

